(function(){
    'use strict'; 
    angular.module('Filters').filter('bbaTimeConverter', bbaTimeConverter);
    bbaTimeConverter.$inject = []; 

    function bbaTimeConverter(){
        return function(seconds){
            if(seconds != null) {
                const hours   = Math.floor(seconds / 60 / 60);
                const minutes = Math.floor(seconds / 60) - (hours * 60);
                const secondsLeft = seconds % 60;
                return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;
            }
            else {
                return 'N/A';
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/filters/bbaTimeConverter.js